<template>
  <div>
    <div class="add">
      <Icon type="ios-add-circle-outline" size="26" color="#39f" @click="$emit('add')" />
    </div>
    <Table size="small"  stripe :columns="columns" :data="dependencyList">
      <template slot-scope="{ row, index }" slot="flowName">
        <Select
          v-model="row.flowName"
          filterable
          clearable
          style="width: 200px"
          transfer-class-name="custom-select-dependen"
          transfer
          @on-change="$emit('editDependency',row.flowName, index)"
        >
          <Option
            v-for="item in dependencyOptions"
            :value="item.flowName"
            :key="item.flowName"
            >{{ item.flowName }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="jobId">
        <Select
          v-model="row.jobId"
          filterable
          clearable
          style="width: 200px"
          transfer
          transfer-class-name="custom-select-dependen"
          @on-change="$emit('editDependencyJob',row.jobId, index)"
        >
          <Option
            v-for="item in dependencyJobList[index]"
            :value="item"
            :key="item"
            >{{ item }}</Option
          >
        </Select>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button type="error" size="small" @click="$emit('remove',index)">删除</Button>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: {
    dependencyList: {
      type: Array,
      default: [],
    },
    dependencyOptions: {
      type: Array,
      default: [],
    },
    dependencyJobList: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      columns: [
        // {
        //   title: "工程名",
        //   slot: "projectName",
        //   width: 240,
        // },
        {
          title: "工作流名",
          slot: "flowName",
          width: 240,
        },
        {
          title: "节点名",
          slot: "jobId",
          width: 240,
        },
        {
          title: "表名",
          key: "table",
        },
        {
          title: "调度配置",
          key: "cronExpression",
        },
        {
          title: "责任人",
          key: "submitUser",
        },
        {
          title: "操作",
          slot: "action",
        },
      ]
    };
  },

  methods: {
    // add(){
    //   this.$emit('add')
    // },
    // remove(index){
    //   this.$emit('remove',index)
    // },
    // editDependency(projectName, index){
    //   this.$emit('editDependency',projectName, index)
    // }
  },
};
</script>
<style scoped>
.add {
  margin-bottom: 10px;
}
.ivu-table-wrapper {
  padding-bottom: 40px;
}
</style>
<style>
.custom-select-dependen{
  max-height: 300px!important;
}
</style>
